import React, { useState } from 'react'
import { formatDateTime, getCorporateDocketTAT, showUser } from '../../utils/shortcuts'
import { smartTrim, truncate } from '../../utils'
import { Link } from 'react-router-dom'

export default function MobileCorporateDockets({ data, user, setDocData, setDocInfoModal, setCorpDocketChangeModal, setDocketTicketModal }) {
    const [showTab, setTab] = useState(0)
    return (
        <div className='row mt-3'>
            <div className='col-12'>
                {data.map((row, i) => <div className="shadow-sm p-3 mb-2 bg-white rounde" key={i}>
                    <div className='row' onClick={() => setTab(i)}>
                        <div className='col-6'>
                            <h6 className='mb-0'>
                                <button type="button" className="btn btn-secondary btn-sm text-center me-2 downBtnTable"><i className={`fas fa-chevron-${showTab === i ? 'down' : 'right'}`}></i></button>
                                {row?.code}
                            </h6>
                        </div>
                        <div className='col-6  text-end'>
                            <h6 className='mb-0'>
                                {row?.status}
                            </h6>
                        </div>
                        <div className='col-12 mt-3'>
                            <div className='row m-0'>
                                {row?.is_manual_docket && <div className='col-12 text-center'>
                                    <span className="badge text-dark bg-light" role='button'>Manual Docket</span>
                                </div>}
                                <div className='col-4'>
                                    <p className='mb-1'>Team:</p>
                                </div>
                                <div className='col-8 text-end'>
                                    <p className='mb-1'>{showUser(row?.get_team, false)}</p>
                                </div>

                            </div>
                        </div>
                        <div className='col-12'>
                            <div className='row m-0'>
                                <div className='col-4'>
                                    <p className='mb-1'><small>Location A:</small></p>
                                </div>
                                <div className='col-8 text-end'>
                                    <p className='mb-1'><small>{row?.get_circuit?.location_a ?? '-'}</small></p>
                                </div>
                            </div>
                        </div>
                        <div className='col-12'>
                            <div className='row m-0'>
                                <div className='col-4'>
                                    <p className='mb-1'><small>Location B:</small></p>
                                </div>
                                <div className='col-8 text-end'>
                                    {/* <p className='mb-1'><small>{showUser(row?.get_field_team, false)}</small></p> */}
                                    <p className='mb-1'><small>{row?.get_circuit?.location_b ?? '-'}</small></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {showTab === i && <div className='row detailsinerTableMobile'>
                        <div className='col-12 mb-2'>
                            <div className='row'>
                                <div className='col-3'>
                                    <h6>ID:</h6>
                                </div>
                                <div className='col-9'>
                                    <h6>{row?.code}</h6>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 mb-2'>
                            <div className='row'>
                                <div className='col-3'>
                                    <h6>Problem:</h6>
                                </div>
                                <div className='col-9'>
                                    <h6>{row?.get_problem?.title ? smartTrim(row?.get_problem?.title, 50) : '-'}</h6>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 mb-2'>
                            <div className='row'>
                                <div className='col-3'>
                                    <h6>Created:</h6>
                                </div>
                                <div className='col-9'>
                                    <h6>{formatDateTime(row?.created_at, 'DD-MM-YY h:mm a')}</h6>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 mb-2'>
                            <div className='row'>
                                <div className='col-3'>
                                    <h6>Live TAT:</h6>
                                </div>
                                <div className='col-9'>
                                    <h6>{getCorporateDocketTAT(row?.closed_at, row.created_at)}</h6>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 mb-2'>
                            <div className='row'>
                                <div className='col-3'>
                                    <h6>Closed:</h6>
                                </div>
                                <div className='col-9'>
                                    <h6>{formatDateTime(row?.closed_at, 'DD-MM-YY h:mm a')}</h6>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 mb-2'>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className="d-flex gap-1">

                                        <Link to={`/docket/corporate/${row.code}`} className='btn btn-primary pb-0 btn-style-light' title='View'>
                                            <span className="material-icons-sharp">
                                                visibility
                                            </span>
                                        </Link>

                                        {user?.permissions?.dockets?.can_view_corp_docket_ticket || user?.permissions?.dockets?.can_add_corp_docket_ticket ? <button className="btn btn-warning btn-style-light pb-0" onClick={() => { setDocketTicketModal(true); setDocData(row); }} title='Ticket Support' ><span className="material-icons-sharp">live_help</span></button> : ""}

                                        {row.status !== 'Cancelled' && <>

                                            <button className="btn btn-dark btn-style-light pb-0" onClick={() => { setDocInfoModal(true); setDocData(row); }} title='Quick Info' ><span className="material-icons-sharp">info</span></button>

                                            {row.status !== 'Closed' ? <>
                                                {user?.permissions?.dockets?.can_change_teams_corp_docket ? <button className="btn btn-info btn-style-light pb-0" onClick={() => { setDocData(row); setCorpDocketChangeModal(true); }} title='Change Teams' ><span className="material-icons-sharp">group</span></button> : ''}

                                                {user?.permissions?.dockets?.can_close_corp_docket ? <Link className="btn btn-danger btn-style-light pb-0" to={`/docket/corporate/close/${row.code}`} title='Close Docket' ><span className="material-icons-sharp">stop</span></Link> : ''}
                                            </> : ''}
                                            {/* {!user?.permissions?.dockets?.change && <>
                                                {row.status === 'Resolved' && row.has_recent_docket.status ? <Link className="btn btn-danger btn-style-light pb-0" style={{ marginLeft: 5 }} to={`/docket/add?circuit=${row.circuit}`} title={`Docket Reopened until ${formatDateTime(row.has_recent_docket.opened_until, 'MMMM Do YYYY, h:mm a')}`}>
                                                    <span className="material-icons-sharp">restart_alt</span></Link> : ''}
                                            </>} */}
                                        </>}


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                </div>)}



            </div>

        </div>
    )
}
